var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"careers"},[_c('div',{staticClass:"block-label"},[_vm._v("\n        Карьера\n    ")]),_vm._l((_vm.user.userCareers),function(career){return _c('ParticipantCareerBlock',{key:career.id,staticClass:"margin-row",attrs:{"item":career}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }